export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_23-f5be947be38a015db2b15816b162787e.jpg";